import {ColonistMembershipProduct} from '../../../../../../../shared/store/ColonistMembershipProduct.ts'
import {type UIStoreState} from '../../../../../../shared/scripts/store/UIStoreState.ts'
import {createDivIn, createParagraphIn} from '../../../../../../shared/scripts/ui_utils/DomUtils.ts'
import {UICheckoutAjaxEndPoints} from '../../../../../../shared/scripts/ui_checkout/UICheckoutAjaxEndPoints.ts'
import {UIMMobileWebviewCommunication} from '../../../../ui_mobile_communication/UIMMobileWebviewCommunication.ts'
import {type LocalizedPricingSubscriptionsPayload, MobileWebviewCommunicationActions} from '@colonist/mobile'
import {ClientUserState} from '../../../../../../shared/scripts/ClientUserState.ts'
import {type UIStoreGiftOverlayController} from '../../../../../../shared/scripts/store/gift/UIStoreGiftOverlayController.ts'
import {UIStoreMembershipProductView} from '../../../../../../shared/scripts/store/UIStoreMembershipProductView.ts'
import {UIMDeviceHandler} from '../../../UIMDeviceHandler.ts'
import {PaymentMethod} from '../../../../../../../shared/store/BaseColonistStoreProduct.ts'
import {type TranslationObject} from '@colonist/i18n'
import {UIDeviceController} from '../../../../../../shared/scripts/ui_html/UIDeviceController.ts'

export class UIMStoreMembershipProductView extends UIStoreMembershipProductView {
    constructor(container: HTMLDivElement, storeState: UIStoreState, membershipProduct: ColonistMembershipProduct, giftOverlay: UIStoreGiftOverlayController, localizedSubscription?: LocalizedPricingSubscriptionsPayload) {
        super(container, storeState, membershipProduct, giftOverlay, localizedSubscription)

        if(UIDeviceController.isUserOnAndroidApp()) {
            this.showAndroidAnnualPrice()
        }

        createDivIn(this.buttonsContainer, 'loading-spinner')
    }

    private showAndroidAnnualPrice() {
        if(!this.membershipProduct.billedAnnually) return
        this.priceDiv.replaceChildren()

        const annualPrice = this.getMembershipPriceString('annual')
        const baseAnnualPrice = ColonistMembershipProduct.getBaseAnnualPriceOfAnnualMembership(this.membershipProduct.type)
        if(baseAnnualPrice == undefined) return

        const context = this.localizedPriceData ? 'localized' : 'biggerPrice'
        const amount = this.localizedPriceData ? `${this.localizedPriceData.currency}${this.localizedPriceData.price}` : annualPrice

        createParagraphIn(this.priceDiv, {key: 'strings:storePage.sections.membership.billing.yearlyPayment', options: {context: 'strikethrough', amount: baseAnnualPrice}}, 'strikethrough-price', '')

        this.membershipPrice = createParagraphIn(this.priceDiv, {key: 'strings:storePage.sections.membership.billing.yearlyPayment', options: {context: context, amount: amount}}, '', '')
    }

    protected sendToCheckout() {
        if(!ClientUserState.userState?.isLoggedIn) return
        this.buttonsContainer.classList.add('loading')
        if(UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true) {
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.PurchaseMembership, {subscriptionId: this.membershipProduct.mobileIAPSKUId, userId: ClientUserState.userState.id, offerToken: ''})

            setInterval(() => {
                this.buttonsContainer.classList.remove('loading')
            }, 5000)
            return
        }
        void UICheckoutAjaxEndPoints.executeStripeColonistProductPurchaseSession(this.membershipProduct.storeProductType, this.membershipProduct.type, this.membershipProduct.itemQuantity)
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true)
    }

    protected manageSubscription() {
        const isStripePaymentMethod = ClientUserState.userState?.items.membershipPaymentMethod == PaymentMethod.Stripe
        if(UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true && !isStripePaymentMethod && ClientUserState.userState?.id) {
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowManageSubscriptions, {
                subscriptionId: this.membershipProduct.mobileIAPSKUId,
                userId: ClientUserState.userState.id,
            })
            return
        }
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true)
        super.manageSubscription()
    }

    protected override addBestValueHint() {
        if(!this.membershipProduct.bestValue) return

        this.productDiv.classList.add('store_page_membership_best_value_border')
        const badge = createDivIn(this.headerDiv, 'badge-white badge-lg')
        createParagraphIn(badge, {key: 'strings:storePage.bestValue'}, '')
    }

    protected getDisclaimerKey(): TranslationObject {
        if(!UIDeviceController.isUserOnAndroidApp()) {
            return super.getDisclaimerKey()
        }

        const monthlyPrice = this.getMembershipPriceString('monthly')

        const context = this.localizedPriceData ? 'localized' : ''
        const amount = this.localizedPriceData ? `${this.localizedPriceData.currency}${((this.localizedPriceData.price ?? 0) / 12).toFixed(2)}` : monthlyPrice
        if(this.membershipProduct.billedAnnually) return {key: 'strings:storePage.sections.membership.billing.monthlyEqual', options: {context: context, amount: amount}}

        return {key: 'strings:storePage.sections.membership.billing.monthly'}
    }
}
